import pkg from '../../package.json';
import { APP_VERSION } from './appVersion';

export const SENTRY_RELEASE = `${pkg.name}@${APP_VERSION}`;
